import { ACADEMIC_PERIODS_NAMES } from '../../../constants';
import { SubjectAreaNames } from '../../../interfaces/EOAInterface';
import type {
  FinalizedTranscriptDetailsResponse,
  TranscriptsBySubjectAreaType,
  AcademicPeriodData,
  AcademicPeriodNames,
  Course,
} from '../../../interfaces/TranscriptsInterface';

export const parseTranscriptsBySubjectArea = (
  transcripts: FinalizedTranscriptDetailsResponse['transcripts'],
  subjectAreas: SubjectAreaNames[]
): TranscriptsBySubjectAreaType => {
  const allTranscripts = (transcripts.RIGOROUS_ACADEMIC || [])
    .concat(transcripts.ON_THE_CUSP || [])
    .concat(transcripts.STRUGGLING || []);

  const parsedData = {} as TranscriptsBySubjectAreaType;

  subjectAreas.forEach((subjectArea) => {
    parsedData[subjectArea] = [];

    allTranscripts.forEach((transcript) => {
      const rowData = { studentNumber: transcript.school_student_number } as AcademicPeriodData;

      (Object.keys(ACADEMIC_PERIODS_NAMES) as AcademicPeriodNames[]).forEach((academicPeriodName) => {
        const academicPeriod = transcript.academic_periods.find((ap) => ap.period === academicPeriodName);
        let courses = [] as Course[];

        if (academicPeriod) {
          academicPeriod.terms.forEach((term) => {
            const subjectAreaData = term.subject_areas.find((area) => area.name === subjectArea);
            if (subjectAreaData) courses = courses.concat(subjectAreaData.courses);
          });
        }

        rowData[academicPeriodName] = courses;
      });

      parsedData[subjectArea].push(rowData);
    });
  });

  return parsedData;
};

export const getCoursesCount = (studentData: AcademicPeriodData): number =>
  studentData.NINTH_GRADE.length +
  studentData.TENTH_GRADE.length +
  studentData.ELEVENTH_GRADE.length +
  studentData.TWELFTH_GRADE.length;

export const hasCoursesInSubjectArea = (studentsData: AcademicPeriodData[]): boolean =>
  studentsData.reduce((total, studentData) => total + getCoursesCount(studentData), 0) > 0;
